"use client";

import { BreadCrumb } from "@/components/templates";
import styles from "./styles.module.scss";
import { Job } from "../jobs/data";
import { FC } from "react";
import uniqid from "uniqid";

export interface DetailJobProps {
  job: Job;
}

export const DetailJob: FC<DetailJobProps> = ({ job }) => {
  return (
    <>
      <div className={styles.detail_job}>
        <div className={styles.bread_crumb_container}>
          <BreadCrumb
            data={[
              {
                url: "/",
                label: "Accueil",
              },
              {
                url: "/jobs",
                label: "Jobs",
              },
              {
                url: `/jobs/${job.slug}`,
                label: job.title,
              },
            ]}
            className={styles.bread_crumb}
          />
        </div>
        <div className={styles.title_and_paragraph}>
          <h1>{job.title}</h1>
          <div
            className={styles.paragraph_container}
            dangerouslySetInnerHTML={{ __html: job.text }}
          ></div>
        </div>
        <div className={styles.details_container}>
          {job.details.map(({ title, text }) => (
            <div key={uniqid()} className={styles.item}>
              <h2>{title}</h2>
              <ul
                className={styles.text_container}
                dangerouslySetInnerHTML={{ __html: text }}
              ></ul>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
